export function setCenterFromUrl(state, payload) {
    state.centerFromUrl = payload;
}

export function setCategoriesFromUrl(state, payload) {
    state.categoriesFromUrl = payload;
}

export function setPoiDetailFromUrl(state, payload) {
    state.poiDetailFromUrl = payload
}

export function setWaypointsFromUrl(state, payload) {
    state.waypointsFromUrl = payload
}

export function setInterimStopsFromUrl(state, payload) {
    state.interimStopsFromUrl = payload
}

export function setTransportModeFromUrl(state, payload) {
    state.transportModeFromUrl = payload
}

export function setSpecialContentFromUrl(state, payload) {
    state.specialContentFromUrl = payload
}